module.exports = __webpack_public_path__ + "static/media/call-feedback-all-good-grey.b80fd6e5.svg";